// Discreet logging for everything location related.
//
// The recording used to narrate itself into the browser console on every tick
// ("Position buffered", "Sending location data to server", …). That is noise in
// production and needlessly conspicuous if the PWA is ever opened on a desktop.
//
// Off by default. Enable with setLocationTrackingDebug(true) or by setting
// localStorage 'tracko_debug_location' to '1'. console.error is deliberately
// NOT routed through here — real failures must stay diagnosable.

const DEBUG_KEY = 'tracko_debug_location'

let debugLoggingEnabled: boolean | null = null

export const isLocationDebugEnabled = (): boolean => {
  if (debugLoggingEnabled === null) {
    try {
      debugLoggingEnabled =
        import.meta.env?.DEV === true || localStorage.getItem(DEBUG_KEY) === '1'
    } catch {
      debugLoggingEnabled = false
    }
  }
  return debugLoggingEnabled
}

export const setLocationTrackingDebug = (enabled: boolean): void => {
  debugLoggingEnabled = enabled
  try {
    if (enabled) {
      localStorage.setItem(DEBUG_KEY, '1')
    } else {
      localStorage.removeItem(DEBUG_KEY)
    }
  } catch {
    // localStorage unavailable — the in-memory flag still applies
  }
}

export const locationLog = (...args: unknown[]): void => {
  if (isLocationDebugEnabled()) {
    console.log(...args)
  }
}

export const locationWarn = (...args: unknown[]): void => {
  if (isLocationDebugEnabled()) {
    console.warn(...args)
  }
}
